import React, { useState, useMemo } from 'react';
import { toastr } from 'react-redux-toastr';

import './SettingsContent.scss';

export default (props) => {
  const { bot, updateBotRequest, user } = props;

  const [project, setProject] = useState(
    bot.settings && bot.settings.storage
      ? bot.settings.storage.project || ''
      : ''
  );
  const [storage, setStorage] = useState(
    bot.settings && bot.settings.storage
      ? bot.settings.storage.storage || ''
      : ''
  );
  const [key, setKey] = useState(
    bot.settings && bot.settings.storage
      ? bot.settings.storage.key || '{}'
      : '{}'
  );
  const [file, setFile] = useState();
  const [edit, setEdit] = useState(false);

  const keyName = useMemo(() => {
    return JSON.parse(key).client_email || '';
  }, [key]);

  const updateBot = (file_key) => {
    if (!bot) return;

    if (!bot.settings) bot.settings = {};
    bot.settings.storage = { project, key: file_key || key, storage };

    if (file_key) setKey(file_key);
    updateBotRequest(bot._id, { settings: bot.settings });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (edit) {
      setEdit(false);
      let error, file_key;
      if (file) {
        [error, file_key] = await loadFile()
          .then((r) => [null, r])
          .catch((e) => [e, null]);
        if (error) return toastr.error('Erro', error.message || error);
      }

      updateBot(file_key);
    } else {
      setEdit(true);
    }
  };

  const onCancel = (e) => {
    e.preventDefault();
    setProject(
      bot.settings && bot.settings.storage
        ? bot.settings.storage.project || ''
        : ''
    );
    setStorage(
      bot.settings && bot.settings.storage
        ? bot.settings.storage.storage || ''
        : ''
    );
    setKey(
      bot.settings && bot.settings.storage
        ? bot.settings.storage.key || '{}'
        : '{}'
    );
    setEdit(false);
  };

  const loadFile = async () => {
    if (!file) throw new Error('Selecione um arquivo JSON antes');
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const text = e.target.result;
        if (text.length > 5000)
          return reject('Arquivo excedeu o tamanho permitido');

        let parsed;
        try {
          parsed = JSON.parse(text);
        } catch (exc) {
          return reject('Arquivo não é um JSON válido');
        }

        resolve(JSON.stringify(parsed, null, 4));
      };

      reader.readAsText(file);
    });
  };

  const onChooseFile = (e) => {
    setFile(e.target.files[0]);
  };

  return (
    <div className="from-group">
      <div className="title">
        {'Configuração de Criador '}
        <strong>{'Armazenamento'}</strong>
      </div>
      <div className="subtitle mt-2">
        {'Configure o comportamento do bloco "Coleta" no background do seu bot'}
      </div>
      <br></br>
      <form className="form-group">
        <div className="form-group mt-3">
          <label>{'Nome do projeto'}:</label>
          <input
            disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
            className="form-control"
            type="text"
            placeholder={'my project'}
            value={project}
            onChange={(e) => setProject(e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>{'Nome do storage'}:</label>
          <input
            disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
            className="form-control"
            type="text"
            placeholder={'my storage'}
            value={storage}
            onChange={(e) => setStorage(e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <div className="form-group">
            <label>{'Chave'}:</label>
            <br></br>
            <pre>{keyName ? `Email Associado: ${keyName}` : 'Nenhuma'}</pre>
          </div>
        </div>
        {(edit || key === '{}') && (
          <div className="form-group mt-3">
            <label>{'Selecione um arquivo JSON:'}</label>
            <input
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              type="file"
              className="form-control-file"
              onChange={onChooseFile}
            />
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            type="button"
            disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
            className="btn btn-primary"
            onClick={onSubmit}
          >
            {edit || key === '{}' ? 'salvar' : 'editar chave'}
          </button>
          {(edit || key === '{}') && (
            <button
              type="button"
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              className="btn btn-danger"
              style={{ marginLeft: '15px' }}
              onClick={onCancel}
            >
              {'cancelar'}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};
